import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-norecord',
  templateUrl: './norecord.component.html',
  styleUrls: ['./norecord.component.css']
})
export class NorecordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
